import {
    AGENT_FETCH, GET_AGENT_HISTORY, BOT_CONFIG_SETTING,
    GET_AGENT_CONVERSATION_PUBLIC, GET_UNREAD_INFO_DETAIL,POST_LEADS_WITHOUT_LOGIN
} from "../../commons/api_url"

import http from '../axios';


// 获取 agent history
export const getAgentHistoryFetch = (agentId) => new Promise((resolve, reject) => {
    http("get", `${GET_AGENT_HISTORY}/${agentId}`).then(res => {
        resolve(res);
    }, error => {
        reject(error)
    })
})

export function getAgentConverationNOLOGINFetch(data) {
    return new Promise((resolve, reject) => {
        http("post", `${GET_AGENT_CONVERSATION_PUBLIC(data.publicUUID)}?projectId=${data.projectId}&businessAccountId=${data.businessAccountId}`, data).then(res => {
            resolve(res);
        }, error => {
            reject(error)
        })
    })
}



export function getChatBotGlobalParamsFetch(agentId, params) {
    return new Promise((resolve, reject) => {
        http("get", `${AGENT_FETCH}/${agentId}/botsetting`, params).then(res => {
            resolve(res);
        }, error => {
            reject(error)
        })
    })
}



export function getAllConversationsFetch(id) {
    return new Promise((resolve, reject) => {
        http("get", `${GET_UNREAD_INFO_DETAIL(id)}`).then(res => {
            resolve(res);
        }, error => {
            reject(error)
        })
    })
}


export function getBotConfigsFetch(agentId, params) {
    return new Promise((resolve, reject) => {
        http("get", `${BOT_CONFIG_SETTING(agentId)}`, params).then(res => {
            resolve(res);
        }, error => {
            reject(error)
        })
    })
}

export function postLeadWithoutLoginFetch(conversationId,data) {
    return new Promise((resolve, reject) => {
        http("post", `${POST_LEADS_WITHOUT_LOGIN}?conversationId=${conversationId}`, data).then(res => {
            resolve(res);
        }, error => {
            reject(error)
        })
    })
}

